import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ConfigService } from "src/app/services/config/config.service";
import { LiveDealerService } from "src/app/services/lobby/live-dealer.service";

@Component({
    selector: 'app-live-dealer-tile',
    templateUrl: './live-dealer-tile.component.html',
    styleUrls: ['./live-dealer-tile.component.scss'],
})

export class LiveDealerTileComponent implements OnInit {

    @Input() tileData: any;
    @Input() isAuthenticated: boolean;
    @Input() isSelected: boolean = false;
    @Input() superCategory: string;

    @Output() onTileActionLoggedIn = new EventEmitter<any>();
    @Output() onTileActionLoggedOut = new EventEmitter<any>();
    @Output() selectTile = new EventEmitter<any>();

    protected favoriteKeywordsMap: { [id: string]: boolean } = {};
    public imagesPath: string;

    constructor(
        private readonly config: ConfigService,
        private readonly liveDealerService: LiveDealerService,
    ) {

    }

    ngOnInit(): void {
        this.imagesPath = `${this.config.getConfig().CDN_BASEURL}/assets/icon/`;
        setTimeout(() => this.checkFavouriteKeywords());
    }

    protected liveDealerTileAction(data: any): any {
        this.selectTile.emit(data);
        if (this.isAuthenticated) {
            return this.onTileActionLoggedIn.emit(data);
        }

        return this.onTileActionLoggedOut.emit(data);
    }

    public async checkFavouriteKeywords() {
        if (!this.isAuthenticated) return;
        try {
            const favoriteKeywordsPayload = await this.liveDealerService.checkFavouriteKeyword();
            const favoriteKeywords: any[] = favoriteKeywordsPayload?.payload ?? [];
            this.favoriteKeywordsMap = favoriteKeywords.reduce((map, keyword) => {
                map[keyword.id] = true;
                return map;
            }, {});
        } catch (error) {
            console.error("Error fetching favorite keywords:", error);
        }
    }

    protected isFavouriteKeyword(id: any): boolean {
        return !!this.favoriteKeywordsMap[id];
    }

    async makeFavouriteKeyword(data): Promise<void> {
        try {
            const response = await this.liveDealerService.addFavouriteKeyword(data).toPromise();
            if (response.result) {
                const payload = response?.payload;
                this.favoriteKeywordsMap = payload.reduce((map, keyword) => {
                    map[keyword.id] = true;
                    return map;
                }, {});
            } else {
                console.error("Error adding Fav Keyword", response);
            }
        } catch (error) {
            console.error("Error adding Fav Keyword", error);
        }
    }

    async removeFavouriteKeyword(data): Promise<void> {
        try {
            const response = await this.liveDealerService.removeFavouriteKeyword(data).toPromise();
            if (response.result) {
                const payload = response?.payload;
                this.favoriteKeywordsMap = payload.reduce((map, keyword) => {
                    map[keyword.id] = true;
                    return map;
                }, {});
            } else {
                console.error("Error Removing Fav Keyword", response);
            }
        } catch (error) {
            console.error("Error Removing Fav Keyword", error);
        }
    }
}